import { useSelectorEq } from "commons/store/common";
import Button from "components/ui/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import type { IState } from "store/modules";
import styled from "styled-components";

const ProfileNoticeStyled = styled.div`
  position: fixed;
  top: 16px; /* 원하는 위치에 맞게 조정 가능 */
  left: 50%;
  transform: translateX(-50%);
  width: 65%;
  height: 72px;
  background-color: #e65f3e;
  border-radius: 8px;
  z-index: 99;

  @media screen and (max-width: 767px) {
    width: 96%;
    height: 90px;
  }
`;

const ContentWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 30px;
  position: relative;
  > div {
    width: 80%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p {
      overflow: hidden;
      white-space: break-spaces;
      text-overflow: ellipsis;
      color: #fbf2f2;
      font-size: 0.98rem;
      &:first-child {
        font-weight: 600;
        font-size: 1.15rem;
        color: #fff;
      }
    }
  }
  button {
    position: relative;
    background-color: #2c3030;
    color: #fff;
    font-size: 1.05rem;
    font-weight: 600;
    border: 1px solid #2c3030;
    overflow: hidden;
    white-space: break-spaces;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: 767px) {
    p {
      font-size: 0.95rem;
    }
    button {
      font-size: 0.98rem;
      padding: 0;
    }
  }
`;
function ProfileNoticeContent() {
  const navgate = useNavigate();
  const { t } = useTranslation();
  return (
    <ProfileNoticeStyled>
      <ContentWrap>
        <div>
          {/* <p>정산을 위해 기본 정보를 입력해주세요</p> */}
          <p>{t("popup.profile.title")}</p>
          {/* <p>
            필수 정보를 입력하지 않을 경우 지급이 어렵습니다. 원활한 서비스를 이용하시려면 필수 정보를 입력해주세요.
          </p> */}
          <p>{t("popup.profile.sub")}</p>
        </div>
        <Button
          // text={"정보 입력하기"}
          text={t("popup.profile.btn")}
          radius={8}
          onClick={() => {
            navgate("/admin/setting");
          }}
        />
      </ContentWrap>
    </ProfileNoticeStyled>
  );
}
/**
 * 프로필 미 입력시
 * @returns
 */
function ProfileNotice(): JSX.Element {
  const { flag } = useSelectorEq((state: IState) => ({
    flag: state.navigates.userProfileFlag,
  }));

  return flag === false ? <ProfileNoticeContent /> : <></>;
}

export default React.memo(ProfileNotice);
